import { fetch } from '../config/axios'

// 我惠逛街
export function shopping (params) {
  return fetch(params, '/shopping')
}
// 精品服装分类
export function clothingCategoryList (params) {
  return fetch(params, '/clothingCategoryList')
}

// 我惠逛街根据服装分类ID查询商品列表
export function findByClothingCategoryId (params) {
  return fetch(params, '/findByClothingCategoryId')
}
// 我惠出行
export function travelInfo (params) {
  return fetch(params, '/travelInfo')
}

// 我惠美食
export function food (params) {
  return fetch(params, '/food')
}
// 我惠云超
export function yunChao (params) {
  return fetch(params, '/yunChao')
}
// 天猫
export function tmallIndex (params) {
  return fetch(params, '/tmallIndex')
}
// 淘宝
export function taobaoIndex (params) {
  return fetch(params, '/taobaoIndex')
}
// // 京东
// export function jingdongIndex (params) {
//   return fetch(params, '/v1/jingdongIndex')
// }
// 聚划算
export function juhuasuanIndex (params) {
  return fetch(params, '/juhuasuanIndex')
}
// 拼多多
export function pinduoduoIndex (params) {
  return fetch(params, '/pinduoduoIndex')
}
// 根据一级分类ID查询二级分类和商品列表
export function findAmoyProductListByYjCategory (params) {
  return fetch(params, '/findAmoyProductListByYjCategory')
}
// 根据二级分类查询淘客商品
export function findAmoyProductListByEjCategory (params) {
  return fetch(params, '/findAmoyProductListByEjCategory')
}

// 云店首页
export function cloudShopIndex (params) {
  return fetch(params, '/cloudShopIndex')
}

// 云店一级分类
export function findProductByYjCategory (params) {
  return fetch(params, '/findProductByYjCategory')
}
// 云店二级分类
export function findProductByEjCategory (params) {
  return fetch(params, '/findProductByEjCategory')
}
// 补单专区/砍一刀（爆品）/新品商品列表
export function explosiveOrNewsList (params) {
  return fetch(params, '/explosiveOrNewsList')
}
// 云店店铺
export function shopProductList (params) {
  return fetch(params, '/shopProductList')
}

// 淘客商品详情
export function amoyProductDetail (params) {
  return fetch(params, '/amoyProductDetail')
}

// 云店商品详情
export function cloudProductDetail (params, isHidden) {
  return fetch(params, '/cloudProductDetail', false, isHidden)
}
// 加入购物车
export function addCart (params) {
  return fetch(params, '/addCart', true)
}
// 云店商品评价列表
export function commentList (params) {
  return fetch(params, '/commentList')
}
// 附近商圈地图
export function mapShopList (params) {
  return fetch(params, '/mapShopList')
}

// 附近商圈
export function businessShopList (params) {
  return fetch(params, '/businessShopList')
}
// 实体商家详情
export function findShopDesc (params) {
  return fetch(params, '/findShopDesc')
}

// 抢券
export function grabVoucher (params) {
  return fetch(params, '/grabVoucher')
}

// 根据商家ID查询商家代金券列表
export function findVoucherListByshopId (params) {
  return fetch(params, '/findVoucherListByshopId')
}
//

// 跨境优选
export function kuajingIndex (params) {
  return fetch(params, '/kuajingIndex')
}

// 闪购
export function brandIndex (params) {
  return fetch(params, '/brandIndex')
}
// 专场
export function brandProductList (params) {
  return fetch(params, '/brandProductList')
}
// 9.9包邮
export function shippingList (params) {
  return fetch(params, '/shippingList')
}
// 9.9包邮,
export function sixhuneigList (params) {
  return fetch(params, '/sixhuneigList')
}
// 秒杀
export function spikeList (params) {
  return fetch(params, '/spikeList')
}
// 收藏商家
export function collectionOrCancelShop (params) {
  return fetch(params, '/collectionOrCancelShop', true)
}


// 拼团列表
export function groupProductList (params) {
  return fetch(params, '/groupProductList')
}
// 扶贫省份
export function provinceList (params) {
  return fetch(params, '/provinceList')
}
// 扶贫专区根据省份ID查询市县列表
export function cityAndDistrictList (params) {
  return fetch(params, '/cityAndDistrictList')
}
// 扶贫产品信息
export function povertyAlleviationDetail (params) {
  return fetch(params, '/povertyAlleviationDetail')
}
// 扶贫-贫困户列表接口
export function ForHP_UserList (params){
  return fetch(params, '/ForHP_UserList')
}
// 留言
export function leaveMessage (params) {
  return fetch(params, '/leaveMessage', true)
}



// WEBPACK FOOTER //
// ./src/api/benefit.js